import {
  AppRemixIcon,
  AppModal,
  AppTextArea,
  AppInput,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import NewsletterFileButtons from './NewsletterFileButtons';

const NewsletterEntryOptions = (props) => {
  const { newsletterEntry } = props;

  return (
    <>
      <NewsletterFileButtons newsletterEntry={newsletterEntry} />
      <AppModal
        title="Información del envío"
        size="xl"
        trigger={
          <span
            className="btn btn-xs btn-outline-info ml-2"
            title="Ver información de envío"
          >
            <AppRemixIcon icon="eye" />
          </span>
        }
      >
        <>
          <div className="row">
            <div className="col-lg-4">
              <h5>Lista de distribución utilizada</h5>
              <DistributionTable>
                {newsletterEntry?.sendedMailingList?.map((m) => (
                  <li key={m}>{m}</li>
                ))}
              </DistributionTable>
            </div>
            <div className="col-lg-8">
              <h5>Email</h5>
              <AppInput
                title="Asunto"
                value={newsletterEntry?.sendedSubject}
                isReadOnly
              />
              <AppTextArea
                title="Cuerpo del mail"
                placeholder="Se mostrará bajo entre el contenido por defecto principal y el final. Ver Vista Previa."
                value={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: newsletterEntry?.sendedBody,
                    }}
                  />
                }
                isReadOnly
                height="346px"
              />
            </div>
          </div>
        </>
      </AppModal>
    </>
  );
};

export default NewsletterEntryOptions;

const DistributionTable = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0 0 6px;
  border: 1px solid #ddd;
  height: 400px;
  overflow-y: scroll;
`;
